import { Card, CardContent, Typography, Stack, Box } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

export default function KpiCard({ title, value, subtitle, icon, trend }) {
  return (
    <Card elevation={0} sx={{ height: "100%", borderRadius: '10px', bgcolor:'#f7f7f7a4', border:'1px solid gainsboro', boxShadow:'none'}}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between">
            
          <Box>
            <Typography fontSize={'14px'} color="text.secondary">
              {title}
            </Typography>
            <Typography variant="h5" fontWeight="800">
              {value}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
          
        </Stack>

        {trend && (
          <Stack direction="row" spacing={1} mt={1} alignItems="center">
            <TrendingUpIcon color="success" fontSize="small" />
            <Typography variant="caption" color="success.main">
              {trend}
            </Typography>
          </Stack>
        )}
      </CardContent>
    </Card>
  );
}
